export const GENERAL = {
  TITLE: 'Halan',
};
